/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomEditCard from '../../../../common/components/CustomEditCard/CustomEditCard';
import { Grid, Typography } from '@mui/material';
import CardContentTile from '../../../../common/components/CardContentTile/CardContentTile';
import _ from 'lodash';
import CurrentSalaryEditModalController from '../../../../common/Modals/Salary/CurrentSalaryEditModal/CurrentSalaryEditModalController';
import { fonts, themes } from '../../../../common/themes/themes';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import {
  check_user_permission,
  getAmount,
} from '../../../../common/configs/utils';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../../common/helper';
import { useSelector } from 'react-redux';
import { usePermission } from '../../../../hooks';

interface propsType {
  allAllowancesData: any;
  allAdditionalBenefitsData: any;
  totalNetSalary: any;
  salaryStartDate: any;
  currentCurrency: string;
  isLoading?: boolean;
  trans?: any;
}
const CurrentSalaryPresenter: React.FC<propsType> = ({
  allAdditionalBenefitsData,
  allAllowancesData,
  totalNetSalary,
  salaryStartDate,
  currentCurrency,
  isLoading,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);

  const userCanShowSalary = usePermission('Employee Portal Show Salary');

  return (
    <div>
      <CustomEditCard
        card_title={trans('Current Salary')}
        card_height="380px"
        onClick={() => setOpenModal(true)}
        showEditButton={false}
      >
        {isLoading ? (
          <>
            <Loader height={100} width={200} />
          </>
        ) : userCanShowSalary ? (
          <div>
            {allAllowancesData?.length || allAdditionalBenefitsData?.length ? (
              <>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    color: themes.primary,
                    fontSize: fonts.subtitle,
                  }}
                >
                  {trans('Effective Date')} :{' '}
                  <DateField
                    value={salaryStartDate}
                    format={baseDateFormatting}
                  />
                </Typography>

                {_.map(allAllowancesData, (allowance: any) => {
                  if (allowance?.value > 0) {
                    return (
                      <CardContentTile
                        tile_key={allowance?.title}
                        tile_value={`${currentCurrency} ${getAmount(
                          allowance?.value,
                        )}`}
                      />
                    );
                  }
                })}
                {_.map(allAdditionalBenefitsData, (benefit: any) => {
                  if (benefit?.amount > 0) {
                    return (
                      <CardContentTile
                        tile_key={benefit?.title}
                        tile_value={`${currentCurrency} ${getAmount(
                          benefit?.amount,
                        )}`}
                      />
                    );
                  }
                })}
                <CardContentTile
                  tile_key={trans('NET SALARY')}
                  tile_value={`${currentCurrency} ${getAmount(totalNetSalary)}`}
                  key_color={themes.primary}
                  value_color={themes.primary}
                  is_bold={true}
                />
              </>
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Current Salary Not set!')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </div>
        ) : (
          <div
            style={{
              color: 'red',
              padding: '30px',
              borderLeft: '4px solid red',
              fontWeight: 'bold',
              opacity: '0.6',
            }}
          >
            {trans("You Don't have Permission please contact with admin")}
          </div>
        )}
      </CustomEditCard>

      {/* Current Salary Edit Modal */}

      {openModal && (
        <CurrentSalaryEditModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          allAllowancesData={allAllowancesData}
          allAdditionalBenefitsData={allAdditionalBenefitsData}
          trans={trans}
        />
      )}
    </div>
  );
};

export default CurrentSalaryPresenter;
